/**
 * 浮动购物车按钮 - 移动端优化
 * 适用于 Shopify Prestige 主题
 */

(function() {
  'use strict';

  // 仅在移动端执行
  if (window.innerWidth > 749) return;

  // 配置
  const CONFIG = {
    selectors: {
      floatingBtn: '[data-floating-add-to-cart]',
      floatingContainer: '.floating-cart-button',
      productForm: 'form[action*="/cart/add"]',
      productGallery: 'product-gallery',
      submitButton: 'button[type="submit"]'
    },
    classes: {
      visible: 'visible',
      adding: 'adding',
      added: 'added'
    },
    thresholds: {
      showStart: 200,  // 图片底部距离视口底部多少px开始显示
      hideWhenBelow: 100  // 图片底部低于视口顶部多少px时隐藏
    },
    animation: {
      addedDuration: 2000  // "已添加"状态持续时间（毫秒）
    }
  };

  // 获取DOM元素
  const elements = {
    floatingBtn: document.querySelector(CONFIG.selectors.floatingBtn),
    floatingContainer: document.querySelector(CONFIG.selectors.floatingContainer),
    productForm: document.querySelector(CONFIG.selectors.productForm),
    productGallery: document.querySelector(CONFIG.selectors.productGallery)
  };

  // 验证必要元素是否存在
  if (!elements.floatingBtn || !elements.floatingContainer ||
      !elements.productForm || !elements.productGallery) {
    console.warn('Floating cart button: Required elements not found');
    return;
  }

  /**
   * 节流函数 - 优化滚动性能
   */
  function throttle(func, wait) {
    let timeout = null;
    let previous = 0;

    return function(...args) {
      const now = Date.now();
      const remaining = wait - (now - previous);

      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        func.apply(this, args);
      } else if (!timeout) {
        timeout = setTimeout(() => {
          previous = Date.now();
          timeout = null;
          func.apply(this, args);
        }, remaining);
      }
    };
  }

  /**
   * 更新浮动按钮的可见性
   */
  function updateButtonVisibility() {
    const galleryRect = elements.productGallery.getBoundingClientRect();
    const galleryBottom = galleryRect.bottom;
    const galleryTop = galleryRect.top;
    const windowHeight = window.innerHeight;

    // 显示条件：图片底部在视口内且距离底部有一定距离
    const shouldShow = galleryBottom > CONFIG.thresholds.showStart &&
                      galleryBottom < windowHeight &&
                      galleryTop < windowHeight - 100;

    if (shouldShow) {
      elements.floatingContainer.classList.add(CONFIG.classes.visible);
    } else {
      elements.floatingContainer.classList.remove(CONFIG.classes.visible);
    }
  }

  /**
   * 获取当前选中的变体ID
   */
  function getSelectedVariantId() {
    // 尝试多种方式获取变体ID
    const variantIdInput = elements.productForm.querySelector('[name="id"]');
    if (variantIdInput) {
      return variantIdInput.value;
    }

    // Prestige 主题可能使用的其他方式
    const variantSelect = elements.productForm.querySelector('select[name="id"]');
    if (variantSelect) {
      return variantSelect.value;
    }

    return null;
  }

  /**
   * 检查是否选择了所有必需的变体选项
   */
  function validateVariantSelection() {
    const variantId = getSelectedVariantId();

    if (!variantId) {
      return {
        valid: false,
        message: '請選擇商品選項'
      };
    }

    return {
      valid: true,
      variantId: variantId
    };
  }

  /**
   * 显示错误提示
   */
  function showError(message) {
    // 可以自定义错误显示方式
    alert(message);

    // 或者滚动到原始按钮位置
    const originalButton = elements.productForm.querySelector(CONFIG.selectors.submitButton);
    if (originalButton) {
      originalButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /**
   * 处理加入购物车点击
   */
  async function handleAddToCart(event) {
    event.preventDefault();

    // 验证变体选择
    const validation = validateVariantSelection();
    if (!validation.valid) {
      showError(validation.message);
      return;
    }

    // 更新按钮状态
    elements.floatingBtn.classList.add(CONFIG.classes.adding);
    elements.floatingBtn.disabled = true;

    try {
      // 触发原始表单的提交逻辑
      const submitButton = elements.productForm.querySelector(CONFIG.selectors.submitButton);

      if (submitButton) {
        // 模拟点击原始按钮，利用主题的原生逻辑
        submitButton.click();

        // 成功状态
        elements.floatingBtn.classList.remove(CONFIG.classes.adding);
        elements.floatingBtn.classList.add(CONFIG.classes.added);
        elements.floatingBtn.textContent = '已加入購物車 ✓';

        // 恢复按钮状态
        setTimeout(() => {
          elements.floatingBtn.classList.remove(CONFIG.classes.added);
          elements.floatingBtn.textContent = '加入購物車';
          elements.floatingBtn.disabled = false;
        }, CONFIG.animation.addedDuration);
      }
    } catch (error) {
      console.error('Add to cart error:', error);

      // 错误状态
      elements.floatingBtn.classList.remove(CONFIG.classes.adding);
      elements.floatingBtn.disabled = false;
      showError('加入購物車失敗，請重試');
    }
  }

  /**
   * 初始化事件监听
   */
  function initEventListeners() {
    // 滚动事件 - 使用节流优化性能
    window.addEventListener('scroll', throttle(updateButtonVisibility, 100), { passive: true });

    // 点击事件
    elements.floatingBtn.addEventListener('click', handleAddToCart);

    // 监听变体变化（如果需要更新按钮状态）
    const variantInputs = elements.productForm.querySelectorAll('input[name="option1"], input[name="option2"], input[name="option3"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        // 变体改变时可以更新按钮状态或文本
        const validation = validateVariantSelection();
        elements.floatingBtn.disabled = !validation.valid;
      });
    });
  }

  /**
   * 初始化
   */
  function init() {
    // 初始检查按钮可见性
    updateButtonVisibility();

    // 绑定事件
    initEventListeners();

    console.log('Floating cart button initialized');
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
